const vuexDynamicModuleLoader = (name, module) => ({
    async created() {
      if (this.$store.hasModule(name)) {
        return;
      }
      this.$store.registerModule(name, module);
    },
  });

export default vuexDynamicModuleLoader;
